import { render, staticRenderFns } from "./exceptionsApply.vue?vue&type=template&id=36990ce5&scoped=true&"
import script from "./exceptionsApply.vue?vue&type=script&lang=js&"
export * from "./exceptionsApply.vue?vue&type=script&lang=js&"
import style0 from "./exceptionsApply.vue?vue&type=style&index=0&id=36990ce5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36990ce5",
  null
  
)

export default component.exports